var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0822 8.00448L8.55654 22.5501C7.25938 23.8613 3.38017 24.4616 2.43789 23.5915C1.49562 22.7215 2.18089 18.8371 3.47804 17.5259L18.0037 2.98036C18.6744 2.34071 19.5684 1.98897 20.4945 2.00026C21.4206 2.01157 22.3056 2.38503 22.9605 3.04087C23.6155 3.69669 23.9885 4.58295 23.9997 5.51036C24.0111 6.43779 23.6598 7.33286 23.021 8.00448H23.0822Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24H12",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/Edit_icon.4882caee2e058e4f6fcc373b6f643440.svg";
export { ForwardRef as ReactComponent };